// Our server reaches the API on the visitor's behalf - rendering a page, and passing the visitor's own calls on -
// so Cloudflare tells the API our address rather than the visitor's. This header carries the visitor's own across
// that hop, under a name of ours because Cloudflare overwrites CF-Connecting-IP on every request it proxies.
const HEADER = 'x-visitor-ip'

// Cloudflare fronts this server too, so the visitor's request already says where it came from. Without Cloudflare
// (local development) the proxy in front of us leaves the address in X-Forwarded-For, or it is only on the socket.
function visitorIp (req) {
  const headers = (req && req.headers) || {}
  const socket = (req && (req.socket || req.connection)) || {}
  return [headers['cf-connecting-ip'], String(headers['x-forwarded-for'] || '').split(',')[0], socket.remoteAddress]
    .map(value => String(value || '').trim()).find(Boolean) || ''
}

// A visitor can send this header themselves, so what we know always replaces it - and where we know nothing,
// nothing reaches the API.
function forwardVisitor (proxyReq, req) {
  const ip = visitorIp(req)
  if (ip) proxyReq.setHeader(HEADER, ip)
  else proxyReq.removeHeader(HEADER)
}

// The same for requests we make ourselves, which carry only the headers we give them.
function visitorHeaders (req) {
  const ip = visitorIp(req)

  return ip ? { [HEADER]: ip } : {}
}

module.exports = { HEADER, visitorIp, forwardVisitor, visitorHeaders }
